/** ****************************************************************************
 ***************************************************************************** */
export const generateId = (prefix=''): string => {
    return `${prefix || 'app'}-${new Date().getTime()}-${Math.floor(Math.random() * 10000 + 1)}-${Math.floor(
        Math.random() * 10000 + 1
    )}`;
};

/** ****************************************************************************
 ***************************************************************************** */
export const capitalize = (text= ''): string => {
    if (typeof text !== 'string') { return ''; }

    const reg = /^(\s+)?([a-zæøå])/;
    const result = text.match(reg);
    if (result && result[2]) {
        text = text.replace(result[2], result[2].toUpperCase());
    }
    return text;
};

/** ****************************************************************************
 ***************************************************************************** */
export const formatTranslatedText = (args?: (number | string)[], forceCapitalize?: boolean, text= ''): string => {
    (args ?? []).forEach( (v: string | number) => {
        text = text.replace( '{}', `${v}`);
    });
    return forceCapitalize ? capitalize(text.toLowerCase()) : text;
}

/** ****************************************************************************
***************************************************************************** */
export const getOffset = (target: any): number[]  => {
    const size = [0, 0];
    if (target) {
        do {
            size[0] += target.offsetLeft || 0;
            size[1] += target.offsetTop || 0;
            target = target.offsetParent;
        } while (target);
    }
    return size;
};

/** ****************************************************************************
 ***************************************************************************** */
export const scrollBodyTop = (where?: number, duration?: number, targetId='', deltaValue=0 ): void => {
    if ( where === undefined && targetId ){
        const target = document.getElementById( targetId );
        if ( target ){
            where = getOffset( target )[1];
        }
    }

    const top = (where && !isNaN(where) && where > 0 ? where : 0) + (deltaValue);
    if ( duration ) {
        const render = (to: number, element: any) => {
            const start = element.scrollTop;
            const change = to - start;
            const startDate = + new Date();

            // @ts-ignore
            const easeInOutQuad = (t, b, c, d) => {
                let t2 = t;
                t2 /= d / 2;
                if (t2 < 1) { return (c / 2) * t2 * t2 + b; }

                t2 -= 1;
                return (-c / 2) * (t2 * (t2 - 2) - 1) + b;
            };

            const animateScroll = () => {
                const currentDate = +new Date();
                const currentTime = currentDate - startDate;
                element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration), 10);
                if (currentTime < duration) {
                    requestAnimationFrame(animateScroll);
                } else {
                    element.scrollTop = to;
                }
            };
            animateScroll();
        }

        render(top, (document.scrollingElement || document.documentElement) );
        render(top, document.body);
    } else {
        document.body.scrollTop = top;
        document.documentElement.scrollTop = top;
    }
}
